import { render } from "./ScreenShot.vue?vue&type=template&id=69ee5777&scoped=true"
import script from "./ScreenShot.vue?vue&type=script&lang=js"
export * from "./ScreenShot.vue?vue&type=script&lang=js"

import "./ScreenShot.vue?vue&type=style&index=0&id=69ee5777&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ee5777"]])

export default __exports__